import * as React from 'react';
import styled from 'styled-components';
import {ConstBreakPoint} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableSectionElement>, HTMLTableSectionElement> {
}

const TbodyDefault: React.FC<IProps> = (props) => {

    const { ...TbodyProps } = props;

    return(<tbody {...TbodyProps} />);

};

const Tbody = styled(TbodyDefault)`
    display: block;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        display: table-row-group;
    }
`;

export default Tbody;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/table/tbody.tsx